import { useState } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../../auth/useAuth";
import { Sidebar } from "./Sidebar";
import { TopBar } from "./TopBar";
import { MobileTabBar } from "./MobileTabBar";
import { ToastContainer } from "../ui/ToastContainer";
import AwaitingAssociationPage from "../../pages/AwaitingAssociationPage";

export function DashboardLayout() {
  const [collapsed, setCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const { isAuthenticated, associations, loading } = useAuth();

  // Authenticated user with no scope yet — usually self-signed-up, pending
  // an admin to associate them. Show a dedicated holding screen instead of
  // the dashboard so we don't render menus/queries that assume an
  // org/customer/operation exists.
  if (!loading && isAuthenticated && (associations?.length ?? 0) === 0) {
    return (
      <>
        <AwaitingAssociationPage />
        <ToastContainer />
      </>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50">
      <Sidebar
        collapsed={collapsed}
        onToggle={() => setCollapsed(!collapsed)}
        mobileOpen={mobileOpen}
        onMobileClose={() => setMobileOpen(false)}
      />
      <TopBar
        sidebarCollapsed={collapsed}
        onMobileMenuOpen={() => setMobileOpen(true)}
      />
      <main
        className={`pt-16 pb-16 md:pb-0 transition-all duration-200 ${
          collapsed ? "md:ml-16" : "md:ml-60"
        }`}
      >
        <div className="p-4 md:p-6">
          <Outlet />
        </div>
      </main>
      <MobileTabBar />
      <ToastContainer />
    </div>
  );
}
